import { useTranslation } from 'react-i18next'

import { QA_NAME_SHOW_MORE_BUTTON } from '../../../../constants/qa'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../../Button'

import * as styles from './ToggleVisibilityButton.module.css'

function ToggleVisibilityButton({
  className = styles.ToggleVisibilityButton,
  isOpen,
  itemsCount,
  qaName = QA_NAME_SHOW_MORE_BUTTON,
  text,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <ButtonArrow
        underlined
        className={className}
        height={BUTTON_HEIGHT_24}
        iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
        isOpen={isOpen}
        qaName={qaName}
        text={t(text, {
          itemsCount,
        })}
        onClick={onClick}
      />
    </div>
  )
}

export default ToggleVisibilityButton
